import $ from "./jquery-global";

// 1. Bootstrap SCSS (wewnątrz main.scss)
import "../scss/main.scss";
import "../scss/responsive.scss";

// 2. Ikony, fonty
import "../fonts/LineIcons.css";

// 3. CSS pluginów
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "magnific-popup/dist/magnific-popup.css";
import "bootstrap-select/dist/css/bootstrap-select.css";
import "ion-rangeslider/css/ion.rangeSlider.css";

// 4. JS pluginów
import "owl.carousel";
import "magnific-popup";
import "bootstrap-select";
import "ion-rangeslider";

// 5. Bootstrap JS
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/tab";
import "bootstrap/js/dist/popover";
import "bootstrap/js/dist/tooltip";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/dropdown";

// 6. Twoje pluginy i kod
import "./plugins/mapify/mapify.js";

// ###########################################
(function ($) {
    "use strict";

    $(window).on('load', function () {
        recalcPrice();
        var forms = document.getElementsByClassName('needs-validation');
        var validation = Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                } else {
                    var actionURL = $(form).attr('action');
                    var method = $(form).attr('method');

                    $.ajax({
                        type: "POST",
                        url: actionURL,
                        beforeSend: function () {
                            var sendBtn = $('#QuestionForm_QuestionForm_action_sendquestion');
                            sendBtn.prepend('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
                        },
                        data: $(form).serialize(),
                        success: function (response) {
                            var res = jQuery.parseJSON(response);
                            $(document).find('p.alert').remove();
                            $(document).find('.modal-footer').remove();
                            $(document).find('.modal-body').html(res.data);
                        },
                        error: function (response) {
                            $(document).find('p.alert').remove();
                            $(document).find('.modal-footer').remove();
                            $(document).find('.modal-body').html(res.data);
                        }
                    });

                    event.preventDefault();
                    event.stopPropagation();
                }

                form.classList.add('was-validated');
            }, false);
        });

        var owl = $("#main-slide");
        owl.owlCarousel({
            navigation: true,
            pagination: false,
            slideSpeed: 1000,
            stopOnHover: true,
            autoPlay: true,
            loop: true,
            items: 1,
            itemsDesktopSmall: [1024, 1],
            itemsTablet: [600, 1],
            itemsMobile: [479, 1],
        });

        // var flats = $("#listing-carousel");
        // flats.owlCarousel({
        //     navigation: true,
        //     pagination: false,
        //     slideSpeed: 1000,
        //     stopOnHover: true,
        //     autoPlay: true,
        //     loop: true,
        //     items: 1,
        //     itemsDesktopSmall: [1024, 1],
        //     itemsTablet: [600, 1],
        //     itemsMobile: [479, 1],
        // });




        $('.search-select').selectpicker({
            actionsBox: false,
            showTick: true,
            styleBase: 'classic',
            style: 'btn-search-dropdown',
            selectedTextFormat: 'static',
            deselectAllText: 'wyczyść',
            selectAllText: 'Wszystkie',
            dropupAuto: false,
            virtualScroll: false,
            countSelectedText: function (c) {
                return this.title + ' wybrano: ' + c;
            },
        });

        $('.search-select').on('change', function () {
            var selected = $(this).val();
            console.log(selected);
        });

        /* MixitUp
        ========================================================================== */
        // $('#portfolio').mixItUp();

        /* Sticky Nav
        ========================================================================== */
        var stickyToggle = function (sticky, stickyWrapper, scrollElement) {
            var stickyHeight = sticky.outerHeight();
            var stickyTop = stickyWrapper.offset().top;
            if (scrollElement.scrollTop() >= stickyTop) {
                stickyWrapper.height(stickyHeight);
                sticky.addClass("is-sticky");
                $('.navbar-brand').removeClass("block");
            } else {
                sticky.removeClass("is-sticky");
                stickyWrapper.height('auto');
                $('.navbar-brand').addClass("block");
            }
        };
        $('.navbar-toggler').on('click', function() {
            $('#main-navbar').toggleClass('collapse');
        });

        // Find all data-toggle="sticky-onscroll" elements
        $('[data-toggle="sticky-onscroll"]').each(function () {
            var sticky = $(this);
            var stickyWrapper = $('<div>').addClass(''); // insert hidden element to maintain actual top offset on page
            sticky.before(stickyWrapper);
            sticky.addClass('sticky');

            // Scroll & resize events
            $(window).on('scroll.sticky-onscroll resize.sticky-onscroll', function () {
                stickyToggle(sticky, stickyWrapper, $(this));
            });

            // On page load
            stickyToggle(sticky, stickyWrapper, $(window));
        });

        /* tooltip building
        ========================================================================== */
        $('.imp-shape.building').tooltip({
            html: true,
            title: function () {
                return '<h1>Budynek J</h1><p class="free"><span>2</span> wolne</p><p class="booked"><span>4</span> zarezerwowane</p><p class="sold"><span>4</span> sprzedane</p>';
            },
            placement: "top",
            template: "<div class=\"tooltip\" role=\"tooltip\"><div class=\"arrow\"></div><div class=\"tooltip-inner\"></div></div>"
        });

        /* tooltip building
        ========================================================================== */
        $('.imp-shape.flat').tooltip({
            html: true,
            title: function () {
                return '<h1>Mieszkanie nr 47</h1><p>Powierzchnia 49m<sup>2</sup></p><p>Pokoje: 3</p><p class="free text-center text-uppercase">wolne</p>';
            },
            placement: "top",
            template: "<div class=\"tooltip\" role=\"tooltip\"><div class=\"arrow\"></div><div class=\"tooltip-inner\"></div></div>"
        });

        /* simple lightbox
        ========================================================*/
        $('a.lightbox').magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            },
            alignTop: true
        });

        $('a.flat_gallery').magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            },
            alignTop: true
        });

        $('a.flat_cart').magnificPopup({
            type: 'iframe'
        });


        //
        // $("input#showall").on('change', function (el) {
        //     $("polygon.mapify-polygon").toggleClass(function () {
        //         var ret = "mapify-hover ";
        //         ret += $(this).attr('data-status');
        //         return ret;
        //     });
        // });

        // $('.imp-shape').on('click', function () {
        //     let url = $(this).data('url');
        //     window.location.href = url;
        // });


        /* Back Top Link active
        ========================================================*/
        var offset = 200;
        var duration = 500;
        $(window).scroll(function () {
            if ($(this).scrollTop() > offset) {
                $('.back-to-top').fadeIn(400);
            } else {
                $('.back-to-top').fadeOut(400);
            }
        });

        $('.back-to-top').on('click', function (event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 600);
            return false;
        });
    });

    $(document).ready(function () {
        $("img[usemap]").mapify({
            popOver: {
                content: function (zone) {
                    return "<h3>" + zone.attr('data-title') + "</h3>" +
                        "Powierzchnia " + zone.attr('data-area') + "m<sup>2</sup>" +
                        "<p class='status " + zone.attr('data-status') + "'>" + zone.attr('data-status-label') + "</p>";
                },
                delay: 0.1,
                // margin: "15px",
                // height: "90px",
                width: "260px",
                placement: 'left',
            }
        });

        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            $(window).trigger("resize.mapify");
        })
    });


    // ##### google MAP
    if (document.getElementById('conatiner-map') !== null) {

        var container = $('#conatiner-map');
        var $latitude = container.data('lat') || 50.027022,
            $longitude = container.data('lng') || 21.979901,
            $map_zoom = container.data('zoom') || 13,
            $marker_url = container.data('marker') || 'img/location.png',
            $markers = $('#map-markers').children('marker');

        //google map custom marker icon - .png fallback for IE11
        var is_internetExplorer11 = navigator.userAgent.toLowerCase().indexOf('trident') > -1;

        //define the basic color of your map, plus a value for saturation and brightness
        var $main_color = '#2d313f',
            $saturation = -20,
            $brightness = 5;

        //we define here the style of the map
        var style = [
            {
                //set saturation for the labels on the map
                elementType: "labels",
                stylers: [
                    {saturation: $saturation}
                ]
            },
            {	//poi stands for point of interest - don't show these lables on the map
                featureType: "poi",
                elementType: "labels",
                stylers: [
                    {visibility: "off"}
                ]
            },
            {
                //don't show highways lables on the map
                featureType: 'road.highway',
                elementType: 'labels',
                stylers: [
                    {visibility: "off"}
                ]
            },
            {
                //don't show local road lables on the map
                featureType: "road.local",
                elementType: "labels.icon",
                stylers: [
                    {visibility: "off"}
                ]
            },
            {
                //don't show arterial road lables on the map
                featureType: "road.arterial",
                elementType: "labels.icon",
                stylers: [
                    {visibility: "off"}
                ]
            },
            {
                //don't show road lables on the map
                featureType: "road",
                elementType: "geometry.stroke",
                stylers: [
                    {visibility: "off"}
                ]
            },
            //style different elements on the map
            {
                featureType: "transit",
                elementType: "geometry.fill",
                stylers: [
                    {hue: $main_color},
                    {visibility: "on"},
                    {lightness: $brightness},
                    {saturation: $saturation}
                ]
            },
            {
                featureType: "poi",
                elementType: "geometry.fill",
                stylers: [
                    {hue: $main_color},
                    {visibility: "on"},
                    {lightness: $brightness},
                    {saturation: $saturation}
                ]
            },
            {
                featureType: "poi.government",
                elementType: "geometry.fill",
                stylers: [
                    {hue: $main_color},
                    {visibility: "on"},
                    {lightness: $brightness},
                    {saturation: $saturation}
                ]
            },
            {
                featureType: "poi.attraction",
                elementType: "geometry.fill",
                stylers: [
                    {hue: $main_color},
                    {visibility: "on"},
                    {lightness: $brightness},
                    {saturation: $saturation}
                ]
            },
            {
                featureType: "poi.business",
                elementType: "geometry.fill",
                stylers: [
                    {hue: $main_color},
                    {visibility: "on"},
                    {lightness: $brightness},
                    {saturation: $saturation}
                ]
            },
            {
                featureType: "transit",
                elementType: "geometry.fill",
                stylers: [
                    {hue: $main_color},
                    {visibility: "on"},
                    {lightness: $brightness},
                    {saturation: $saturation}
                ]
            },
            {
                featureType: "transit.station",
                elementType: "geometry.fill",
                stylers: [
                    {hue: $main_color},
                    {visibility: "on"},
                    {lightness: $brightness},
                    {saturation: $saturation}
                ]
            },
            {
                featureType: "landscape",
                stylers: [
                    {hue: $main_color},
                    {visibility: "on"},
                    {lightness: $brightness},
                    {saturation: $saturation}
                ]

            },
            {
                featureType: "road",
                elementType: "geometry.fill",
                stylers: [
                    {hue: $main_color},
                    {visibility: "on"},
                    {lightness: $brightness},
                    {saturation: $saturation}
                ]
            },
            {
                featureType: "road.highway",
                elementType: "geometry.fill",
                stylers: [
                    {hue: $main_color},
                    {visibility: "on"},
                    {lightness: $brightness},
                    {saturation: $saturation}
                ]
            },
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [
                    {hue: $main_color},
                    {visibility: "on"},
                    {lightness: $brightness},
                    {saturation: $saturation}
                ]
            }
        ];

        //set google map options
        var map_options = {
            center: new google.maps.LatLng($latitude, $longitude),
            zoom: $map_zoom,
            panControl: false,
            zoomControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            styles: style,
        };

        //inizialize the map
        var map = new google.maps.Map(document.getElementById('conatiner-map'), map_options);
        //add a custom marker to the map

        if ($markers.length > 0) {
            $.each($markers, function (i, val) {
                var $markerElement = $(val)
                var lat = $markerElement.data('lat'),
                    lng = $markerElement.data('lng'),
                    title = $markerElement.data('title'),
                    logoUrl = $markerElement.data('logo'),
                    investmentUrl = $markerElement.data('investment-url'),
                    addres = $markerElement.data('addres');

                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(lat, lng),
                    map: map,
                    visible: true,
                    icon: $marker_url,
                });
            })

        }

        // //add custom buttons for the zoom-in/zoom-out on the map
        // function CustomZoomControl(controlDiv, map) {
        //     //grap the zoom elements from the DOM and insert them in the map
        //     var controlUIzoomIn = document.getElementById('cd-zoom-in'),
        //         controlUIzoomOut = document.getElementById('cd-zoom-out');
        //
        // }
        //
        // var zoomControlDiv = document.createElement('div');
        // var zoomControl = new CustomZoomControl(zoomControlDiv, map);
        //
        // //insert the zoom div on the top left of the map
        // map.controls[google.maps.ControlPosition.LEFT_TOP].push(zoomControlDiv);
    }


    $('.price-history-js').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('#flatPriceHistory').modal('show');

        var id = $(this).data('flat-id');
        var flatName = $(this).data('flat-name');

        $.ajax({
            type: "GET",
            url: "/historia-ceny/" + id,
            success: function (response) {
                $('.price-history-body').html(response);

                if ($('#flat-name').length && flatName.length > 0) {
                    $('#flat-name').text(flatName);
                }

            },
            error: function (response) {
                $('.price-history-body').html('<p class="alert alert-danger">Wystąpił błąd podczas wczytywania danych.<br/>Proszę spróbować później</p>');
            },
            complete: function () {
                $('.price-history-loader').hide();
            }

        });
    })

    $('.choose-garage').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('#garageChooseModal').modal('show');

        var id = $(this).data('investment-id');

        $.ajax({
            type: "GET",
            url: "/dostepne-garaze/lista/" + id,
            success: function (response) {
                $('.choose-additionals-content')
                    .html(response)

                    .find('a.select-garage')
                    .on('click', function (e) {
                        e.stopPropagation();
                        e.preventDefault();

                        var garageData = {
                            id: $(this).data('garage-id'),
                            price: $(this).data('garage-price'),
                        };

                        localStorage.setItem('selectedGarage', JSON.stringify(garageData));
                        $('#garageChooseModal').modal('hide');

                        recalcPrice();
                    });

            },
            error: function (response) {
                $('.choose-additionals-content').html('<p class="alert alert-danger">Wystąpił błąd podczas wczytywania danych.<br/>Proszę spróbować później</p>');
            },
            complete: function () {
                $('.choose-additionals-loader').hide();
            }

        });
    })

    $('.choose-storage').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('#storageChooseModal').modal('show');

        var id = $(this).data('flat-id');

        $.ajax({
            type: "GET",
            url: "/dostepne-komorki/komorki/" + id,
            success: function (response) {
                $('.choose-additionals-content-storages')
                    .html(response)

                    .find('a.select-storage')
                    .on('click', function (e) {
                        e.stopPropagation();
                        e.preventDefault();

                        var storageData = {
                            id: $(this).data('storage-id'),
                            floor: $(this).data('storage-floor'),
                            price: $(this).data('storage-price'),
                        };

                        localStorage.setItem('selectedStorage', JSON.stringify(storageData));
                        $('#storageChooseModal').modal('hide');

                        recalcPrice();
                    });

            },
            error: function (response) {
                $('.choose-additionals-content-storages').html('<p class="alert alert-danger">Wystąpił błąd podczas wczytywania danych.<br/>Proszę spróbować później</p>');
            },
            complete: function () {
                $('.choose-additionals-loader').hide();
            }

        });
    })


    function recalcPrice() {
        var flatPrice = $('#flat-price-gross').data('flat-price')
        var selectedGarage = JSON.parse(localStorage.getItem('selectedGarage'));
        var selectedStorage = JSON.parse(localStorage.getItem('selectedStorage'));

        console.log(selectedStorage)
        console.log(selectedGarage)

        var totalPrice = flatPrice;
        if(selectedGarage) {
            totalPrice += selectedGarage.price;
            $('a.choose-garage').text('Zmień garaż')
            $('#choosen-garage').html('Wybrany garaż: ' + selectedGarage.id +'<br/>' + 'Cena: ' + priceFormatter(selectedGarage.price))
        }
        if(selectedStorage) {
            totalPrice += selectedStorage.price;
            $('a.choose-storage').text('Zmień komórkę')
            $('#choosen-storage').html('Wybrana komórka lokatorska: ' + selectedStorage.id +'<br/>'
                + 'Cena: ' + priceFormatter(selectedStorage.price)
                + '<br/>' + 'Piętro: ' + selectedStorage.floor
            )
        }
        $('#total-price-gross').text(priceFormatter(totalPrice));



    }

    function priceFormatter(value) {
        var absValue = Math.abs(value);
        var formatted = absValue.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        var val = formatted + ' zł';
        return value < 0 ? '(' + val + ')' : val;
    }

}($));
